// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDataGrid-cell:focus {
    outline: none !important;
}

.MuiDataGrid-row {
    cursor: pointer;
}

.read-only-row .MuiDataGrid-checkboxInput {
    display: none !important;
}

.react-codemirror2 {
    height: 100%;
}

.CodeMirror {
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/frontend/pages/scripts/scripts.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".MuiDataGrid-cell:focus {\n    outline: none !important;\n}\n\n.MuiDataGrid-row {\n    cursor: pointer;\n}\n\n.read-only-row .MuiDataGrid-checkboxInput {\n    display: none !important;\n}\n\n.react-codemirror2 {\n    height: 100%;\n}\n\n.CodeMirror {\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
